import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import LiveFeed from "./components/LiveFeed";
import ProgressTimeline from "./components/ProgressTimeline";
import HotRanking from "./components/HotRanking";
import Channels from "./components/Channels";
import Faq from "./components/Faq";
import About from "./components/About";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="w-full bg-background-50 text-foreground-900">
      <Navbar />
      <main>
        <Hero />
        <LiveFeed />
        <ProgressTimeline />
        <HotRanking />
        <Channels />
        <Faq />
        <About />
      </main>
      <Footer />
    </div>
  );
}